import type { ReactNode, TdHTMLAttributes, ThHTMLAttributes } from 'react';

import { cn } from './cn';

/**
 * Tabla base. Los diez módulos que vienen son, casi todos, una lista.
 *
 * Accesibilidad que ya viene resuelta acá y que no hay que reinventar:
 * `<caption>` para lectores de pantalla, `scope="col"` en las cabeceras y
 * scroll horizontal contenido (una tabla ancha no debe hacer que se desplace
 * la página entera).
 */
export function Table({
  caption,
  children,
  className,
}: {
  /** Descripción para lector de pantalla. Obligatoria: no es decorativa. */
  caption: string;
  children: ReactNode;
  className?: string;
}): ReactNode {
  return (
    <div className="overflow-x-auto">
      <table className={cn('w-full border-collapse text-sm', className)}>
        <caption className="sr-only">{caption}</caption>
        {children}
      </table>
    </div>
  );
}

export function Th({ className, ...props }: ThHTMLAttributes<HTMLTableCellElement>): ReactNode {
  return (
    <th
      scope="col"
      className={cn(
        'border-b border-border px-4 py-2.5 text-left text-xs font-semibold tracking-wide text-ink-muted uppercase',
        className,
      )}
      {...props}
    />
  );
}

export function Td({ className, ...props }: TdHTMLAttributes<HTMLTableCellElement>): ReactNode {
  return (
    <td className={cn('border-b border-border px-4 py-3 text-ink', className)} {...props} />
  );
}
